import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

function FormModal({ hidden, onDismiss, title, children }) {
  return (
    <>
      <div
        className={`${
          hidden ? "hidden" : "flex flex-col"
        } w-full bg-[#000000CC] h-full overflow-hidden fixed m-0 inset-0 justify-center items-end z-50`}
      >
        <div className="w-[100%] h-full md:w-[80%] lg:w-[50%] overflow-auto bg-neutral-light">
          <div className="flex flex-wrap items-center px-8 py-2 bg-primary text-white">
            <div className="relative w-full max-w-full flex-grow flex items-center justify-between">
              <h3 className="font-semibold text-lg uppercase">{title}</h3>

              <XMarkIcon
                className="w-10 h-10 cursor-pointer hover:shadow-lg hover:rounded-full p-2"
                onClick={onDismiss.bind(null, null)}
              />
            </div>
          </div>
          <div className="flex flex-col p-4 h-auto">{children}</div>
        </div>
      </div>
    </>
  );
}

export default FormModal;
